// Where to send someone after they sign in: the page they asked for, and only a page of this app.
// The address travels as /login?next=/effort%3Fperiod%3D2026-09, so it survives a reload and a hard redirect.

// Pages that are never "where you were going": signing in again from them would loop or confuse.
const NEVER = ['/', '/login', '/change-password'];
const BASE = 'http://app.invalid';

/** The path (with its query and hash) when it is a page of this app, otherwise null. */
export function safeReturnPath(raw: string | null | undefined): string | null {
  // "//host" and "/\host" are read by a browser as another site; anything not starting with one "/" is not a path.
  if (!raw || raw[0] !== '/' || raw[1] === '/' || raw[1] === '\\') return null;
  let url: URL;
  try {
    url = new URL(raw, BASE);
  } catch {
    return null;
  }
  if (url.origin !== BASE || NEVER.includes(url.pathname)) return null;
  return url.pathname + url.search + url.hash;
}

/** The sign-in address for someone who asked for `wanted`: it remembers the page, unless there is nothing to return to. */
export function loginPathFor(wanted: string): string {
  const path = safeReturnPath(wanted);
  return path ? `/login?next=${encodeURIComponent(path)}` : '/login';
}

/** Just the path of a return address, for asking whether a role may open it. */
export function pathnameOf(path: string): string {
  return path.split(/[?#]/)[0];
}
